import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faListOl } from '@fortawesome/pro-light-svg-icons';

export type ProLightListOlProps = IconComponentProps;

export const ProLightListOl = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightListOlProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faListOl}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faListOl}
    />
  );
};

ProLightListOl.displayName = 'ProLightListOl';
